import { render, staticRenderFns } from "./quotation-summary.vue?vue&type=template&id=2351db6a&scoped=true"
import script from "./quotation-summary.vue?vue&type=script&lang=js"
export * from "./quotation-summary.vue?vue&type=script&lang=js"
import style0 from "./quotation-summary.vue?vue&type=style&index=0&id=2351db6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2351db6a",
  null
  
)

export default component.exports